import { useEffect, useState } from 'react';
import Image from 'next/image';
import avancy from '@/images/avancy-gray.svg';

export function GallerySection({ gallery, name = '' }) {
  const [columns, setColumns] = useState(gallery.length);

  useEffect(() => {
    const updateColumns = () => {
      if (window.innerWidth < 600) {
        setColumns(1);
      } else if (window.innerWidth < 940) {
        setColumns(2);
      } else {
        setColumns(gallery.length);
      }
    };

    window.addEventListener('resize', updateColumns);

    updateColumns();

    return () => window.removeEventListener('resize', updateColumns);
  }, [gallery.length]);

  return (
    <div className="w-full py-20 mx-0 bg-primary">
      <section className="flex justify-center flex-grow p-4">
        <div className="flex flex-col items-center justify-center w-full lg:justify-start lg:mx-auto">
          <h1 className="relative font-montserrat text-3xl font-bold text-center text-white md:text-4xl xl:text-[64px] xl:leading-[76.8px]">
            Conheça mais sobre a Empresa
          </h1>
        </div>
      </section>

      <div
        className={`flex justify-center flex-wrap gap-4 px-10 mx-auto ${gallery.length > 4 ? 'max-w-[900px] 2xl:max-w-[1920px]' : "max-w-[852px] xl:max-w-full"} `}
      >
        {gallery.sort((a, b) => a.order - b.order).map((g, i) => (
          <div key={i} className={`h-72 overflow-hidden shadow-sm rounded-4xl`}>
            <Image
              alt={g?.f_name || ''}
              src={g?.f_photo?.url || ''}
              width="10"
              height="10"
              className={`h-full object-center object-cover w-auto rounded-4xl`}
              unoptimized
              onError={(e) => {
                e.target.src = avancy.src;
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
